import { useEffect } from "react";
import { useListContext, useStoreContext } from "react-admin";

/**
 * Clears a <DataTable>'s expanded-row state when the list is unmounted, so
 * rows are not remembered across navigations.
 *
 * react-admin stores the ids of expanded rows in the app-level Store (key
 * `<resource>.datagrid.expanded`), which outlives any single <List> visit,
 * so rows expanded on a previous visit come back expanded. Render this
 * component inside <List>, next to the <DataTable>, to remove the key on
 * unmount; the next visit then starts with nothing expanded.
 *
 * Within a visit the state behaves normally: expanded rows stay expanded,
 * including when they remain visible after a page/filter/sort change.
 */
export const ResetExpandedRows = () => {
  const { resource } = useListContext();
  const { removeItem } = useStoreContext();

  useEffect(() => {
    return () => removeItem(`${resource}.datagrid.expanded`);
  }, [resource, removeItem]);

  return null;
};
